import BaseScene from "@Scenes/BaseScene";

/*-------------- Config -------------------*/
import * as Scenes from '@Config/scenes';

/*--------------- Player ------------------*/

class PlayerScene extends BaseScene
{
    private playerLeaderboardEntry: Networks.LeaderboardEntry;

    constructor()
    {
        super(Scenes.PLAYER);
    }

    /**
     * Initialize Scene
     * @param playerLeaderboardEntry
     */
    public init(playerLeaderboardEntry: Networks.LeaderboardEntry)
    {
        this.playerLeaderboardEntry = playerLeaderboardEntry;
    }

    /**
     * Preloads assets required for the scene
     */
    public preload()
    {
        const leaderboardEntry = this.playerLeaderboardEntry;

        const player = leaderboardEntry.getPlayer();

        const playerID = player.getID();

        const playerImageKey = `player-${playerID}`;

        if (this.textures.exists(playerImageKey) === false)
        {
            this.load.image(playerImageKey, player.getPhoto());
        }
    }

    /**
     * Creates the UI of the scene
     */
    public create()
    {
        this.addPlayerImage();
    }
 
    /**
     * Adds a player image to the scene
     */
    private addPlayerImage()
    {
        const tweenOffsetX = 200;

        const playerX = 95 - tweenOffsetX;
        const playerY = 67;

        const leaderboardEntry = this.playerLeaderboardEntry;

        const player = leaderboardEntry.getPlayer();
        const playerID = player.getID();
        const playerImageKey = `player-${playerID}`;

        const circleMask = this.add.graphics();
        circleMask.fillStyle(0xffffff);
        circleMask.lineStyle(2, 0x000000);
        circleMask.strokeCircle(0, 0, 20);
        circleMask.fillCircle(0, 0, 20);
        circleMask.x = playerX;
        circleMask.y = playerY;

        const mask = circleMask.createGeometryMask();
        const image = this.add.image(playerX, playerY, playerImageKey);
        image.setDisplaySize(70, 70)
        image.setMask(mask);
        image.setOrigin(0.5);

        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', fontSize: '20px' };
        const nameText = this.add.text(playerX + 33, 42, player.getName(), fontStyle);
        const scoreText = this.add.text(playerX + 33, 67, leaderboardEntry.getFormattedScore(), fontStyle);

        this.add.tween({
            targets: [circleMask, image, nameText, scoreText],
            props: {
                x: { value: `+=${tweenOffsetX}` , duration: 500, ease: 'Sine.easeOut'}
            }
        });

    }

}

export default PlayerScene;